const INDEX_ITEMS = [
  { icon: 'ri-star-line', title: '明星八卦', desc: '娱乐圈明星艺人的最新动态与私生活揭秘', count: '2.3万条', color: 'primary' },
  { icon: 'ri-tv-line', title: '综艺影视', desc: '热门综艺幕后故事与影视剧组一手爆料', count: '1.8万条', color: 'accent' },
  { icon: 'ri-live-line', title: '网红达人', desc: '各大平台头部网红的热门话题与争议事件', count: '1.5万条', color: 'secondary' },
  { icon: 'ri-earth-line', title: '国际吃瓜', desc: '海外娱乐八卦译制，全球吃瓜零时差', count: '9800条', color: 'primary' },
  { icon: 'ri-history-line', title: '经典回顾', desc: '那些年轰动全网的经典大瓜完整时间线', count: '7600条', color: 'accent' },
  { icon: 'ri-emotion-line', title: '粉丝圈层', desc: '饭圈动态、应援故事与粉丝文化深度观察', count: '1.1万条', color: 'secondary' },
  { icon: 'ri-survey-line', title: '深度解读', desc: '热门事件的背景分析、人物关系与内幕揭秘', count: '6200条', color: 'primary' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            分门别类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">专题合集</h2>
          <p className="text-sm text-foreground-500 mt-2">七大频道，想吃哪个瓜随你挑</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => {
            const colorMap: Record<string, string> = {
              primary: 'border-primary-200/60 hover:bg-primary-50/50',
              accent: 'border-accent-200/60 hover:bg-accent-50/50',
              secondary: 'border-secondary-200/60 hover:bg-secondary-50/50',
            };
            const iconMap: Record<string, string> = {
              primary: 'text-primary-600 bg-primary-100',
              accent: 'text-accent-600 bg-accent-100',
              secondary: 'text-secondary-600 bg-secondary-100',
            };
            return (
              <a
                key={item.title}
                href={`#index`}
                className={`group flex items-start gap-4 p-5 rounded-xl border bg-background-50 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${colorMap[item.color] || colorMap.primary}`}
              >
                <div className={`shrink-0 w-10 h-10 flex items-center justify-center rounded-lg ${iconMap[item.color] || iconMap.primary}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-1.5">{item.desc}</p>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}